/**
 * Floating WhatsApp button — opens chat directly (no PIN gate).
 * Order CTAs keep PIN gating via data-ffp-requires-pin on product/cart flows.
 */
import { buildWhatsAppUrl } from '@theme/ffp-whatsapp-order';

class FfpWhatsappButton extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('a');
    this.link?.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const number = this.dataset.whatsappNumber?.replace(/\D/g, '');
    const messageLink = this.dataset.whatsappMessageLink;
    const message = this.dataset.defaultMessage || '';

    if (message) {
      event.preventDefault();
      const url = buildWhatsAppUrl(message, { whatsappNumber: number, whatsappMessageLink: messageLink });
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };
}

if (!customElements.get('ffp-whatsapp-button')) {
  customElements.define('ffp-whatsapp-button', FfpWhatsappButton);
}
